import React from "react";
import CommonContainer from "../../components/shared/CommonContainer";
import {
  Box,
  Stack,
  Text,
  Input,
  HStack,
  Button,
  StackDivider,
  Image,
  Avatar,
  Select,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  IconButton,
  VisuallyHiddenInput,
} from "@chakra-ui/react";
import { BiSearch, BiSend, BiTime } from "react-icons/bi";
import MessageCard from "../../components/freelancer/messages/MessageCard";
import {
  BsFillCheckCircleFill,
  BsFillStarFill,
  BsCameraVideo,
  BsImage,
  BsEmojiSmile,
} from "react-icons/bs";
import { ImProfile } from "react-icons/im";
import { IoCallOutline } from "react-icons/io5";
import MessageHandler from "../../components/freelancer/messages/MessageHandler";
import { MdAttachFile } from "react-icons/md";
import EmojiPicker from "emoji-picker-react";
import { CgClose } from "react-icons/cg";
import { AiOutlineLeft } from "react-icons/ai";

export default function FreelancerMessagesPage() {
  const [search, setSearch] = React.useState();
  const [message, setMessage] = React.useState("");
  const [messageScreen, setMessageScreen] = React.useState(false);
  const [messageProfile, setMessageProfile] = React.useState({
    imageUrl: "/images/freelancer/profiles/1.png",
    name: "Robert",
  });
  const [chatSearch, setChatSearch] = React.useState(false);
  function handleEmojiClick(emojiData, event) {
    // setSelectedEmoji(emojiData);
    setMessage((prevState) => prevState + emojiData.emoji);
  }
  const inputRef = React.useRef();
  return (
    <CommonContainer>
      <HStack
        gap={0}
        spacing={0}
        height="80vh"
        mt={5}
        fontSize={{ base: "14px", lg: "16px" }}
      >
        <Stack
          w={{ base: "full", lg: "30%" }}
          bg="#f4f4f4"
          height="100%"
          // overflow="a"
          display={{ base: messageScreen ? "none" : "flex", lg: "flex" }}
        >
          <HStack justifyContent="space-between" py={4} px={2}>
            <Select
              placeholder="All Conversations"
              w="max-content"
              _placeholder={{
                color: "black",
                fontWeight: "bold",
                fontSize: "22px",
              }}
              border="0"
              fontWeight="bold"
              fontSize="22px"
            >
              <option>All</option>
              <option>Few</option>
            </Select>
            <Box
              cursor="pointer"
              onClick={() => {
                setSearch((prevState) => !prevState);
              }}
            >
              <BiSearch size="24px" />
            </Box>
          </HStack>
          {search && (
            <Box px={2} pb={5}>
              <Input
                placeholder="Search Anything"
                border={0}
                borderBottom={"1px"}
                borderRadius={0}
              />
            </Box>
          )}
          <Text
            py={4}
            borderTop="1px"
            borderBottom="1px"
            borderColor="#c5c5c5"
            px={5}
          >
            Recent Chat
          </Text>
          <Stack overflow="scroll">
            {chatListData.map((item, index) => {
              return (
                <MessageCard
                  key={index}
                  imageUrl={item.imageUrl + (index + 1) + ".png"}
                  name={item.name}
                  message={item.message}
                  time={"02:54"}
                  onClick={() => {
                    setMessageScreen(true);
                    setMessageProfile({
                      name: item.name,
                      imageUrl: item.imageUrl + (index + 1) + ".png",
                    });
                  }}
                />
              );
            })}
          </Stack>
        </Stack>
        <Stack
          w={{ base: "full", lg: "70%" }}
          bg="#f4f4f4"
          p={{ base: 2, md: 5 }}
          display={{ base: messageScreen ? "flex" : "none", lg: "flex" }}
          gap={{ base: 1, md: 2 }}
          height="100%"
        >
          {/* Header of chat box */}
          <Box>
            <HStack gap={{ lg: 10 }} w="full" justifyContent="space-between">
              <Box w="full">
                <HStack
                  gap={{ "2xl": 10 }}
                  justifyContent={"space-between"}
                  flexDir={{ base: "column", "2xl": "row" }}
                >
                  <HStack
                    gap={{ md: 10 }}
                    w={{ base: "full", "2xl": "min-content" }}
                    justifyContent="space-between"
                  >
                    <HStack gap={{ lg: 10 }} pb={2} px={1}>
                      <IconButton
                        variant="link"
                        onClick={() => {
                          setMessageScreen(false);
                        }}
                        display={{ lg: "none" }}
                      >
                        <AiOutlineLeft />
                      </IconButton>
                      <Avatar src={messageProfile?.imageUrl} size="lg" />

                      <Box>
                        <HStack color="#0079BC">
                          <Text fontWeight="bold">{messageProfile?.name}</Text>
                          <BsFillCheckCircleFill />
                        </HStack>
                        <HStack>
                          <Box color="#FFBE5B">
                            <BsFillStarFill />
                          </Box>
                          <Text fontWeight="bold">4.8</Text>
                          <Text color="gray.500" fontWeight="bold">
                            (2k)
                          </Text>
                        </HStack>
                      </Box>
                    </HStack>

                    <Text
                      mt={2}
                      color="brand.500"
                      fontWeight="semibold"
                      textDecor={"underline"}
                      cursor={"pointer"}
                      display={{ base: "block", "2xl": "none" }}
                    >
                      View Profile
                    </Text>
                  </HStack>

                  <HStack
                    alignItems="start"
                    divider={<StackDivider color="#c5c5c5" />}
                    gap={5}
                    display={{ base: "none", xl: "flex" }}
                    w={{ base: "full", "2xl": "fit-content" }}
                    justifyContent={{ base: "space-between", "2xl": "start" }}
                  >
                    <Box fontWeight={"medium"} fontSize="16px">
                      <Text mb={1}>From</Text>
                      <HStack>
                        <Image src="/images/gigImage/us-flag.png" w="26px" />
                        <Text color="#909090">United States</Text>
                      </HStack>
                      <HStack
                        justifyContent="space-between"
                        pt={2}
                        display={{ base: "none", md: "flex" }}
                      >
                        <Text color="#909090">Seller Level</Text>
                        <Text fontWeight={"semibold"}>Level 2</Text>
                      </HStack>
                      <Box
                        fontWeight={"medium"}
                        fontSize="16px"
                        display={{ base: "block", md: "none" }}
                        mt={4}
                      >
                        <Text mb={1}>Avg. Response Time</Text>
                        <HStack>
                          <Box color="brand.400">
                            <BiTime size="26px" />
                          </Box>
                          <Text color="#909090">1 Hour</Text>
                        </HStack>
                        <HStack justifyContent="space-between" pt={2}>
                          <Text color="#909090">English</Text>
                          <Text fontWeight={"semibold"}>Conversational</Text>
                        </HStack>
                      </Box>
                    </Box>
                    <Stack
                      alignItems="center"
                      display={{ base: "flex", "2xl": "block" }}
                      fontWeight={"medium"}
                      fontSize="16px"
                    >
                      <Text mb={1}>Member Since</Text>
                      <HStack>
                        <Box color="brand.400">
                          <ImProfile size="26px" />
                        </Box>
                        <Text color="#909090">Feb 2022</Text>
                      </HStack>
                      <HStack
                        justifyContent="space-between"
                        pt={2}
                        display={{ base: "flex", md: "none" }}
                      >
                        <Text color="#909090">Seller Level</Text>
                        <Text fontWeight={"semibold"}>Level 2</Text>
                      </HStack>
                    </Stack>
                    <Box
                      fontWeight={"medium"}
                      fontSize="16px"
                      display={{ base: "none", md: "block" }}
                    >
                      <Text mb={1}>Avg. Response Time</Text>
                      <HStack>
                        <Box color="brand.400">
                          <BiTime size="26px" />
                        </Box>
                        <Text color="#909090">1 Hour</Text>
                      </HStack>
                      <HStack justifyContent="space-between" pt={2}>
                        <Text color="#909090">English</Text>
                        <Text fontWeight={"semibold"}>Conversational</Text>
                      </HStack>
                    </Box>
                  </HStack>
                </HStack>
                <Text
                  mt={2}
                  color="brand.500"
                  fontWeight="semibold"
                  textDecor={"underline"}
                  cursor={"pointer"}
                  display={{ base: "none", "2xl": "block" }}
                >
                  View Profile
                </Text>
              </Box>
            </HStack>
            {/* Line of video call icons */}
            <HStack
              borderTop="1px"
              borderBottom="1px"
              borderColor="inherit"
              mt={{ lg: 4 }}
              marginTop={0}
              justifyContent={"space-between"}
              // display={{base:"none",lg:"flex"}}
            >
              <HStack gap={2}>
                {chatSearch && (
                  <>
                    <Input placeholder="Search Chat..." />
                    <BiSearch size="24px" />
                  </>
                )}
                <IconButton
                  onClick={() => {
                    setChatSearch((prevState) => !prevState);
                  }}
                  variant="unstyled"
                >
                  {chatSearch ? (
                    <CgClose size="24px" />
                  ) : (
                    <BiSearch size="24px" />
                  )}
                </IconButton>
              </HStack>
              <HStack gap={4}>
                <IoCallOutline size="24px" />
                <BsCameraVideo size="24px" />
              </HStack>
            </HStack>
          </Box>
          {/* Box of message */}
          <Stack
            overflow="auto"
            fontSize={{ base: "12px", md: "14px", lg: "16px" }}
          >
            <HStack justifyContent="center" py={2}>
              <Text bg="#f2f2f2" py={2} px={6} borderRadius={10}>
                Today
              </Text>
            </HStack>
            {messageData.map((item, index) => {
              return (
                <MessageHandler
                  key={index}
                  imageUrl={messageProfile.imageUrl}
                  time={item.time}
                  messages={item.message}
                  reply={item.reply}
                />
              );
            })}
          </Stack>
          <Box>
            <Input
              placeholder="Type your message here..."
              border={0}
              value={message}
              size="xs"
              display={{ base: "block", sm: "none" }}
              onChange={(e) => {
                setMessage((prevState) => e.target.value);
              }}
            />
            <HStack gap={{ md: 4 }} justifyContent={{ base: "space-between" }}>
              <HStack
                fontSize={{ base: "12px", md: "16px", xl: "24px" }}
                w={{ base: "full", sm: "fit-content" }}
              >
                <VisuallyHiddenInput ref={inputRef} type="file" />
                <Box
                  cursor="pointer"
                  onClick={() => {
                    inputRef.current.click();
                  }}
                >
                  <BsImage />
                </Box>
                <Box
                  cursor="pointer"
                  onClick={() => {
                    inputRef.current.click();
                  }}
                >
                  <MdAttachFile />
                </Box>
                <Popover>
                  <PopoverTrigger>
                    <IconButton variant="" minWidth={"min-content"}>
                      <BsEmojiSmile />
                    </IconButton>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent w="fit-content">
                      <PopoverArrow />
                      <PopoverBody p={0}>
                        <EmojiPicker
                          onEmojiClick={handleEmojiClick}
                          width={"250px"}
                        />
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </HStack>
              <Input
                placeholder="Type your message here..."
                border={0}
                value={message}
                display={{ base: "none", sm: "block" }}
                onChange={(e) => {
                  setMessage((prevState) => e.target.value);
                }}
              />
              <Button
                bg="brand.500"
                borderRadius={{ base: 4, md: 10 }}
                size={{ base: "xs", md: "md" }}
                color="white"
                px={6}
                // fontSize={{base:"8px",md:"14px"}}
                w={{ base: "120px", md: "" }}
                rightIcon={<BiSend />}
                _hover={{ bg: "brand.400", color: "white" }}
              >
                Send
              </Button>
            </HStack>
          </Box>
        </Stack>
      </HStack>
    </CommonContainer>
  );
}
const chatListData = [
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Robert",
    message: "Robert is typing",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Kimberly",
    message: "hey !",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Steven",
    message: "Are you going?",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Robert",
    message: "Robert is typing",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Kimberly",
    message: "hey !",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Robert",
    message: "Robert is typing",
  },
  {
    imageUrl: "/images/freelancer/profiles/",
    name: "Steven",
    message: "Are you going?",
  },
];
const messageData = [
  {
    imageUrl: "/images/freelancer/profiles/1.png",
    message: [
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's. ",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    ],
    time: "9:48 pm",
    reply: false,
  },
  {
    imageUrl: "/images/freelancer/profiles/2.png",
    message: [
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's. ",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    ],
    time: "9:48 pm",
    reply: true,
  },
  {
    imageUrl: "/images/freelancer/profiles/1.png",
    message: [
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's. ",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    ],
    time: "9:48 pm",
    reply: false,
  },
];
